module.exports = __webpack_public_path__ + "img/hearphones.5ad23000.png";